import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface AgentData {
  [key: string]: {
    short_id: string;
    title: string;
    created_at: string;
    author_name: string;
  }[];
}

export function useGetRevisionHistory(uuid: string, options?: any) {
  const { keycloak } = useKeycloak();

  return useQuery<AgentData>({
    queryKey: ['revision-history', uuid],
    queryFn: async () => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/get_revision_history`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ agentUuid: uuid }),
        }
      );

      const data = await response.json();

      return data?.data || {};
    },
    ...options,
  });
}
